import { useState } from 'react';
import styled from 'styled-components';
import SearchBar from './Tools/Search/Search';

import logo from '../assets/inovision-logo.png';
import { FaSearch } from 'react-icons/fa';
import Helmet from './Helmet';

// header content and logic
const HeaderComp = ({ className, title, home, login, plant }) => {
	const [searchDisplay, setSearchDisplay] = useState('0');
	const displaySearch = () => {
		if (searchDisplay !== '10vh') {
			setSearchDisplay('10vh');
		} else {
			setSearchDisplay(0);
		}
	};

	let heading;
	let link;
	switch (plant) {
		case 'warren':
			title ? (heading = title) : (heading = 'WTAP SMARTInspect IETM');
			home || login ? (link = '/') : (link = '/smart-inspect/warren/overview');
			break;
		case 'montgomery':
			title ? (heading = title) : (heading = 'HMMA SMARTInspect IETM');
			home || login ? (link = '/') : (link = '/smart-inspect/montgomery/overview');
			break;
		case 'fort-wayne':
			title ? (heading = title) : (heading = 'GM Fort Wayne SMARTInspect IETM');
			home || login ? (link = '/') : (link = '/smart-inspect/fort-wayne/overview');
			break;
		case 'springhill':
			title ? (heading = title) : (heading = 'GM Springhill SMARTInspect IETM');
			home || login ? (link = '/') : (link = '/smart-inspect/springhill/overview');
			break;

		default:
			heading = 'Inovision QuickResponse Library';
			link = '/';
			break;
	}

	return (
		<>
			<Helmet title={heading} />
			<header className={className}>
				<div className="header-left">
					<a className="header-logo mb-md-0 me-md-auto" href={link}>
						<img src={logo} alt="logo" />
					</a>
				</div>

				<div className="header-right">
					<h2>{heading}</h2>
					{home || login ? '' : <FaSearch size={30} onClick={displaySearch} />}
				</div>
			</header>
			<SearchBar display={searchDisplay} />
		</>
	);
};

// header styling
const Header = styled(HeaderComp)`
	z-index: 100; // layer header above anything else
	display: flex; // organized left-right
	justify-content: space-between; // header-left and header-right placed on opposite sides
	position: fixed;
	width: 100%; // width of entire page
	height: 10vh; // 8% of screen tall
	top: 0;
	min-height: 48px;
	margin: 0;
	background: white;
	border-bottom: solid black;

	// logo link
	.header-left a {
		color: antiquewhite;
		text-decoration: none;
	}

	// logo spacing
	.header-left {
		height: 100%;
		& img {
			display: block;
			margin: auto 0;
			height: 100%;
		}
	}

	.header-logo {
		display: block;
		height: 100%;
		padding: 10px;
	}

	// title spacing
	.header-right {
		display: flex;
		margin: auto 1rem;
		& h2 {
			font-weight: bold;
			margin: auto;
		}

		& svg {
			display: block;
			height: 100%;
			margin: 10px 10px;

			width: 2.4vw;
			padding: 5px;
			border-radius: 0.5rem;
			&:hover {
				transform: scale(1.1);
			}
		}
	}

	@media screen and (max-width: 480px) {
		.header-right {
			margin: auto 0;
			h2 {
				font-size: medium;
				margin: 0 5px;
			}

			& svg {
				width: 7vw;
				padding: 0;
				height: unset;
				margin: auto 5px;
			}
		}
	}
`;

export default Header;

// <Header plant='warren' />
